(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ergotrans-product-question"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ergotrans-product-question')) {
    customElements.define('ergotrans-product-question', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        const pendingKey = 'etq-pending-' + this.dataset.productId;
        form?.addEventListener('submit', () => {
          const productForm = document.getElementById(this.dataset.productForm);
          const variantId = productForm?.querySelector('[name="id"]')?.value;
          const variants = JSON.parse(this.querySelector('[data-etq-variants]').textContent);
          const variant = variants.find(item => String(item.id) === String(variantId));
          if (variant) {
            this.querySelector('[data-etq-variant]').value = variant.title;
            this.querySelector('[data-etq-variant-id]').value = variant.id;
            this.querySelector('[data-etq-sku]').value = variant.sku || '';
            const productUrl = new URL(this.querySelector('[data-etq-link]').value);
            productUrl.searchParams.set('variant', variant.id);
            this.querySelector('[data-etq-link]').value = productUrl.href;
          }
          try {
            sessionStorage.setItem(pendingKey, JSON.stringify({ variantId: this.querySelector('[data-etq-variant-id]').value, time: Date.now() }));
          } catch {}
        });
        const success = this.querySelector('[data-etq-success]');
        if (success) {
          success.focus({ preventScroll: true });
          try {
            const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
            sessionStorage.removeItem(pendingKey);
            if (pending && Date.now() - pending.time < 1800000) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ event: 'product_question_sent', form_id: 'ergotrans_product_question', product_id: this.dataset.productId, variant_id: pending.variantId });
            }
          } catch {}
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
